export default __webpack_public_path__ + "static/media/email-checked.21b69746.svg";